
import React from 'react';
import logo from '/lovable-uploads/40a4ee59-7714-4091-a6f7-e5ba5819fe5f.png';
import PageLayout from '@/components/PageLayout';
import ToolCard from '@/components/tools/ToolCard';
import CallMeDialog from '@/components/tools/CallMeDialog';
import RechargeDialog from '@/components/tools/RechargeDialog';
import AdBanner from '@/components/AdBanner';
import { useToolItems } from '@/hooks/useToolItems';
import { useTranslation } from 'react-i18next';

const Outils = () => {
  const { t } = useTranslation();
  const {
    toolItems,
    openDialog,
    setOpenDialog,
    openRechargeDialog,
    setOpenRechargeDialog
  } = useToolItems();

  return (
    <PageLayout 
      title={t('tools.title')} 
      logo={logo}
      showBackButton
      colorScheme="bg-gradient-to-r from-yellow-500 to-amber-500"
    >
      {/* Ad Banner for outils page */}
      <AdBanner pageSlug="outils" />
      
      <div className="space-y-4">
        {toolItems.map((item) => (
          <ToolCard
            key={item.id}
            title={item.title}
            description={item.description}
            icon={item.icon}
            color={item.color}
            onClick={item.action}
          />
        ))}
      </div>
      
      <CallMeDialog 
        open={openDialog} 
        onOpenChange={setOpenDialog} 
      />
      
      <RechargeDialog 
        open={openRechargeDialog} 
        onOpenChange={setOpenRechargeDialog} 
      />
    </PageLayout>
  );
};

export default Outils;
